import React, { useState, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import loaderFile from "../../Assets/Images/loader.gif";
import Loader from "../loader/Loader";
import { MakeFileUpload } from "../../utils/handler";

const ImageCropper = (props) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({
    unit: "%", // Can be 'px' or '%'
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [cropCompleted, setCropCompleted] = useState(true);
  const [iscrop, setIsCrop] = useState(true);

  // Dynamic aspect ratio based on shape selection
  const [shape, setShape] = useState("rectangle"); // rectangle | square | circle
  
  const tempFileUpload = async (crop) => {
    setCrop(crop);
    try {
      const formData = new FormData();
      formData.append("file", props.file);
      formData.append("fileCordinates", JSON.stringify(crop));
      formData.append("type", props?.type);
      formData.append("organization_uuid", props?.orgKey);
      const response = await MakeFileUpload("post", formData, "/profile/image/upload");
      if (response.status == 1) {
        props.setKey(response.data.imageKey);
        console.log(response.data);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  useEffect(() => {
    props.file && setImageSrc(URL.createObjectURL(props.file));
    setIsCrop(true);
  }, [props.file]);

  // Change the aspect ratio depending on the shape
  const getAspectRatio = () => {
    if (shape === "circle") {
      return 1; // Circle will have 1:1 aspect ratio (square)
    }
    if (shape === "square") {
      return 1; // Fixed aspect ratio for square
    }
    return undefined; // Rectangle with flexible aspect ratio
  };

  const onCropComplete = () => {
    setCropCompleted(!(crop.width === 0 && crop.height === 0));
    if (imageSrc) {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        const cropX = (crop.x / 100) * image.width;
        const cropY = (crop.y / 100) * image.height;
        const cropWidth = (crop.width / 100) * image.width;
        const cropHeight = (crop.height / 100) * image.height;

        canvas.width = cropWidth;
        canvas.height = cropHeight;
        const ctx = canvas.getContext("2d");

        // Fill the canvas with a white background
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw the image on top of the white background
        ctx.drawImage(
          image,
          cropX * scaleX,
          cropY * scaleY,
          cropWidth * scaleX,
          cropHeight * scaleY,
          0,
          0,
          cropWidth,
          cropHeight
        );

        // Convert canvas content to data URL
        const dataURL = canvas.toDataURL("image/jpeg");
        props.onCropped(dataURL, crop);
        tempFileUpload(crop);
        setIsCrop(null);
      };
    }
  };

  // Handle skipping crop and sending default values
  const handleSkipCrop = async () => {
    props.onCropped(imageSrc, {
      unit: "%",
      x: 0,
      y: 0,
      width: 100,
      height: 100,
    });
    setCrop({
      unit: "%",
      x: 0,
      y: 0,
      width: 100,
      height: 100,
    });
    setIsCrop(null);
    tempFileUpload({
      unit: "%",
      x: 0,
      y: 0,
      width: 100,
      height: 100,
    });
  };

  return (
    <>
      {imageSrc && (
        <>
          {iscrop ? (
            <div className="text-center">
              <ReactCrop
                crop={crop}
                src={imageSrc}
                onChange={(crop, percentCrop) => setCrop(percentCrop)}
                aspect={getAspectRatio()}
              >
                <img src={imageSrc} />
              </ReactCrop>
              <div className="skip-crop-btns d-flex justify-content-center mt-3 mb-4">
                <button
                  type="button"
                  onClick={handleSkipCrop}
                  className="me-2 btn btn-outline-primary skip-btn rounded-pill py-2 px-4"
                >
                  Skip Crop
                </button>
                {cropCompleted && (
                  <button
                    className="btn btn-primary crop-btn rounded-pill py-2 px-4"
                    type="button"
                    onClick={onCropComplete}
                  >
                    Crop Image
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="modal-loader">
              <img
                className="loader"
                src={loaderFile}
                style={{ width: "120px" }}
                alt="Loading..."
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ImageCropper;
